<template>
  <div>
    <b-tab>
      <template v-slot:title>
        <h6>{{ $t('views.dashboard.dispatcher.tasks.myTasks') }}</h6>
      </template>
      <CollapseTaskByTaskType v-if="nextTabIndex  === tabIndex" class="mt-2" :search-params="assignedSearchParams"></CollapseTaskByTaskType>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        <h6>{{ $t('views.dashboard.dispatcher.tasks.tasksInPool') }}</h6>
      </template>
      <CollapseTaskByTaskType v-if="(nextTabIndex + 1) === tabIndex" class="mt-2" :display-assigned="false" :search-params="notAssignedSearchParams"></CollapseTaskByTaskType>
    </b-tab>
  </div>
</template>

<script>
import { getUserRoles } from '@/utils/checkRoles'
import CollapseTaskByTaskType from '@/components/Dashboard/Views/excmtask/CollapseTaskByTaskType'

export default {
  name: 'ServicemanTasks',
  components: {
    CollapseTaskByTaskType
  },

  props: {
    nextTabIndex: {
      type: Number,
      required: true
    },
    tabIndex: {
      type: Number,
      required: true
    }
  },

  destroyed () {
    this.$store.state.checkboxes.selectedTasks = []
  },
  data () {
    return {
      assignedSearchParams: {
        'lastPoolTask.operation': [1, 2, 3],
        'order[id]': 'desc',
        'lastPoolTask.operationTransferUserData': getUserRoles().id_userdata,
        finished: 0
      },
      notAssignedSearchParams: {
        'lastPoolTask.operation': 0,
        'order[id]': 'desc',
        finished: 0
      }
    }
  }
}
</script>
